module.exports = __webpack_public_path__ + "img/cate-icon-8.bda939e5.png";